import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type PushTemplate = {
  push_template_id?: number; // 푸시 알림 템플릿 idx
  push_template?: { [key: string]: Record<string, any> }; // 푸시 알림 템플릿 내용
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PushTemplate
   * --
   */
  getPushTemplates: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PUSH_TEMPLATE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PushTemplate
   * --
   */
  getPushTemplate: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PUSH_TEMPLATE, {
        push_template_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PushTemplate
   * --
   */
  createPushTemplate: async (body: PushTemplate) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PUSH_TEMPLATE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PushTemplate
   * --
   */
  updatePushTemplate: async (body: PushTemplate) => {
    try {
      const { push_template_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PUSH_TEMPLATE, {
        push_template_id: push_template_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PushTemplate
   * --
   */
  deletePushTemplate: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PUSH_TEMPLATE, {
        push_template_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
